import { useQuery } from "@apollo/client";
import { APPOINTMENTS_QUERY } from "@/graphql/appointments";
import { useSalonStore } from "@/lib/store/salon";

interface UseCustomerDetailAppointmentsQueryOptions {
  customerId: string;
  first?: number;
  after?: string;
}

export const useCustomerDetailAppointmentsQuery = ({
  customerId,
  first = 100,
  after,
}: UseCustomerDetailAppointmentsQueryOptions) => {
  const { currentSalon } = useSalonStore();
  const salonId = currentSalon?.id || null;

  return useQuery(APPOINTMENTS_QUERY, {
    variables: {
      salonId: salonId ?? "",
      filters: {
        customerId: customerId,
        first,
        after,
        // TODO: Consider adding date range filtering if needed
        // startDate: DateTime.now().minus({ months: 6 }).toISO(),
      },
    },
    fetchPolicy: "cache-and-network",
    errorPolicy: "all",
    notifyOnNetworkStatusChange: true,
    skip: !customerId || !salonId,
  });
};
